import { render } from "./Toast.vue?vue&type=template&id=15640e15"
import script from "./Toast.vue?vue&type=script&lang=js"
export * from "./Toast.vue?vue&type=script&lang=js"

import "./Toast.vue?vue&type=style&index=0&id=15640e15&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__